import { startMining, stopMining, checkEarnings, resetEarnings } from '../utils/mining';

const miningCommands = async (
  cmd: string,
  setHistory: React.Dispatch<React.SetStateAction<string[]>>,
  connectedNetwork: 'ethereum' | 'solana' | 'base' | 'arbitrum' | 'bnb' | 'optimism' // default to solana
): Promise<string[]> => {
  console.log(`Executing mining command: ${cmd} on ${connectedNetwork}`);

  switch (cmd.toLowerCase()) {
    case 'start':
      return startMining(setHistory, connectedNetwork);
    case 'stop':
      return stopMining(setHistory, connectedNetwork);
    case 'profit':
      return checkEarnings(connectedNetwork);
    case 'reset':
      return resetEarnings(connectedNetwork);
    default:
      return ['⚠ Unknown mining command. Try "mining start", "mining stop", "mining profit", or "mining reset".'];
  }
};

export default miningCommands;
